import { Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../../layout/components/content-header/content-header.component";
import * as moment from "moment/moment";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { AuthenticationService } from "../../../../../auth/service";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { CoreConfigService } from "../../../../../../@core/services/config.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { CandidateService } from "../../../../../modules/recruitment/candidates/candidate.service";
import { locale as italian } from "../../../../../i18n/it";
import { ICurrentUser } from "app/auth/models/user-interface";
import { BargainingService } from "app/modules/recruitment/bargaining/bargaining.service";

@Component({
  selector: "app-future-employee-profile",
  templateUrl: "./future-employee-profile.component.html",
  styleUrls: ["./future-employee-profile.component.scss"],
})
export class FutureEmployeeProfileComponent implements OnInit {
  public contentHeader: IContentHeader;
  public identifier: any;
  public isMyProfile: boolean = true;
  public currentUser: any;
  public eccTableIndex: string = "skill";
  public config: any;
  public me: ICurrentUser;
  public last5years: any = [];
  public currentYear: any = moment().get("years");
  public selectedYearAbsence: any = moment().get("years");
  public currentExperience: any;
  public demand_modal_data: any = [];
  public demand_user: any = [];
  public all_absences: any = [];

  constructor(
    public _utilService: UtilsService,
    public _authenticationService: AuthenticationService,
    private router: Router,
    private activated_route: ActivatedRoute,
    private _coreConfigService: CoreConfigService,
    public _modalService: NgbModal,
    private _absenceService: AbsencesService,
    private _candidatesService: CandidateService,
    private _bargainingService: BargainingService,
  ) {
    this._utilService.disableAutoHideLoading();
    this.contentHeader = {
      headerTitle: italian.data.MENU.PROFILE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "TITLES.FUTURE_EMPLOYEE",
            isLink: true,
            link: "/dashboard/user/future-employees",
          },
          {
            name: italian.data.MENU.PROFILE,
            isLink: false,
          },
        ],
      },
    };
  }

  async ngOnInit() {
    this.me = this._authenticationService.getCurrentUser();

    this.activated_route.paramMap.subscribe(async (params: ParamMap) => {
      if (params.get("user_identifier")) {
        this.identifier = params.get("user_identifier");
        this.isMyProfile = this.identifier === this.me.hash;
      } else {
        this.identifier = this.me.hash;
        this.isMyProfile = true;
      }

      this.currentUser = await this._candidatesService.getCandidate(this.identifier).catch(async () => {
        await this._utilService.showSWALError({ text: "FUTURE_EMPLOYEE_NOT_FOUND" });
        this.router.navigateByUrl("/dashboard/main");
        return false;
      });
      this.currentUser.avatar = "";

      if (this.currentUser) {
        const userBargaining: any = await this._bargainingService.checkIfUserHasBargaining(this.currentUser.hash).then((result: any) => result.bargaining);
        if (userBargaining) {
          this.currentUser.total_daily = userBargaining.total_daily || this.currentUser.total_daily;
          this.currentUser.signed_contract_url = userBargaining.signed_contract_url || null;
        }
      }
      this.contentHeader.breadcrumb.links[2].name = this.currentUser.complete_name;
    });

    this._coreConfigService.config.subscribe((params: any) => {
      this.config = params.custom;
    });

    this.demand_user = await this._absenceService.getMineAbsences();

    this.allAbsences(null);
    this.last5years = [0, 1, 2, 3, 4].map((count) => this.currentYear - count);

    //Metto come primo elemento l'educazione selezionata come primaria
    if (this.currentUser && this.currentUser.educations && this.currentUser.educations.length > 1) {
      this.currentUser.educations = this.currentUser.educations.sort((a) => a.primary);
    }
    setTimeout(() => this._utilService.hideLoading(), 700);
  }

  async goToContract() {
    if (!this._authenticationService.hasCapability("view_others_documents")) {
      return false;
    }

    if (!!this.currentUser.signed_contract_url) {
      await this._utilService.getFile(this.currentUser.signed_contract_url);
      return false;
    }
    if (!!this.currentUser.contract_url) {
      await this._utilService.getFile(this.currentUser.contract_url);
    }
  }

  public allAbsences(event: any = null) {
    let demandUser: any;
    event ? (this.selectedYearAbsence = Number(event.target.value)) : null;
    event
      ? (demandUser = this.demand_user.filter((item: any) => item.status === 1 && (item.from.includes(event.target.value) || item.to.includes(event.target.value))))
      : (demandUser = this.demand_user.filter((item: any) => item.status === 1 && (item.from.includes(this.currentYear) || item.to.includes(this.currentYear))));
    let list: any = {};

    demandUser.map((item: any) => {
      const currentCategory: string = String(item.type.category).trim();
      if (!list[currentCategory]) {
        list[currentCategory] = 0;
      }
      if (item.from === item.to) {
        //Se la data è uguale setto che ha preso soltanto un giorno di ferie o malattia
        list[currentCategory] += 1;
      } else {
        if (currentCategory === "permesso") {
          //Controllo per settare le ore dei permessi
          const from: any = moment(item.from);
          const to: any = moment(item.to);
          //Controllo per la pausa pranzo nel caso dalla differenza togliamo un ora
          if (from.hours() >= 9 && from.hours() <= 13 && to.hours() >= 14 && to.hours() <= 18) {
            list[currentCategory] += to.diff(from, "minutes") / 60 - 1;
          } else {
            list[currentCategory] += to.diff(from, "minutes") / 60;
          }
        } //Se la data e diversa calcola la differenza tra item.from e item.to
        list[currentCategory] += this._utilService.calculateDifferenceBetweenDates(item.from, item.to);
      }
    });
    this.all_absences = [];
    list.ferie = list.ferie || 0;
    list.permesso = list.permesso || 0;
    list.malattia = list.malattia || 0;
    list.infortunio ? (list.malattia += list.infortunio) : list.malattia;
    list.infortunio ? delete list.infortunio : null;
    list.maternità > 0 ? (list.malattia += list.maternità) : list.malattia;
    list.maternità > 0 ? delete list.maternità : null;
    Object.keys(list).map((category: string) => {
      this.all_absences.push({ name: category, amount: list[category] });
    });
    this.all_absences = this.all_absences.sort((a, b) => a.name.localeCompare(b.name));
  }

  public openModalAbsences(modal, category: string, year) {
    this.demand_modal_data = this.demand_user.filter((item: any) => item.type.category === category && item.from.includes(year));
    if (this.demand_modal_data.length > 0) {
      this.demand_modal_data = this.demand_modal_data.map((item) => {
        item.date_from = this._utilService.formatDate(item.from);
        item.date_to = this._utilService.formatDate(item.to);
        return item;
      });
      this._modalService.open(modal, {
        size: "lg",
        centered: true,
      });
    }
  }
}
